export default "__VITE_ASSET__B10ti4Bg__"